import { o_global } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
const breakpoint = o_global.breakpoint ?? {};
const globalBreakpoint = o_global.globalBreakpoint;
export {
  breakpoint,
  globalBreakpoint
};
/*                                          */
